import KidsSection from './KidsSection';

export default KidsSection;
